// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function pxToString(p) {
  if (p === "p20") {
    return "20px";
  } else if (p === "p48") {
    return "48px";
  } else {
    return "10px";
  }
}

function View__Jsx3$View(props) {
  let children = props.children;
  let flexDirection = props.flexDirection;
  let justifyContent = props.justifyContent;
  let alignItems = props.alignItems;
  let mb = props.mb;
  let mt = props.mt;
  let alignBase = v => {
    if (v === "stretch") {
      return "items-stretch";
    } else if (v === "center") {
      return "items-center";
    } else if (v === "flexStart") {
      return "items-start";
    } else if (v === "flexEnd") {
      return "items-end";
    } else {
      return "";
    }
  };
  let justifyBase = v => {
    if (v === "center") {
      return "justify-center";
    } else if (v === "flexStart") {
      return "justify-start";
    } else if (v === "flexEnd") {
      return "justify-end";
    } else {
      return "";
    }
  };
  let dirBase = v => {
    if (v === "column") {
      return "flex-col";
    } else if (v === "row") {
      return "flex-row";
    } else {
      return "";
    }
  };
  let mtClassOfToken = v => {
    if (v === "lg") {
      return "mt-8";
    } else if (v === "md") {
      return "mt-4";
    } else if (v === "sm") {
      return "mt-2";
    } else if (v === "xl") {
      return "mt-16";
    } else if (v === "xs") {
      return "mt-1";
    } else {
      return;
    }
  };
  let mbClassOfToken = v => {
    if (v === "lg") {
      return "mb-8";
    } else if (v === "md") {
      return "mb-4";
    } else if (v === "sm") {
      return "mb-2";
    } else if (v === "xl") {
      return "mb-16";
    } else if (v === "xs") {
      return "mb-1";
    } else {
      return;
    }
  };
  let mtClassAndStyle = mt !== undefined ? (
      typeof mt === "object" ? (
          mt.NAME === "px" ? [
              undefined,
              pxToString(mt.VAL)
            ] : [
              undefined,
              undefined
            ]
        ) : [
          mtClassOfToken(mt),
          undefined
        ]
    ) : [
      undefined,
      undefined
    ];
  let mbClassAndStyle = mb !== undefined ? (
      typeof mb === "object" ? (
          mb.NAME === "px" ? [
              undefined,
              pxToString(mb.VAL)
            ] : [
              undefined,
              undefined
            ]
        ) : [
          mbClassOfToken(mb),
          undefined
        ]
    ) : [
      undefined,
      undefined
    ];
  let hasFlexProps = Stdlib_Option.isSome(alignItems) || Stdlib_Option.isSome(justifyContent) || Stdlib_Option.isSome(flexDirection);
  let flexClass = hasFlexProps ? ["flex"] : [];
  let alignClasses;
  if (alignItems !== undefined) {
    if (typeof alignItems === "object") {
      alignClasses = [];
    } else {
      let cls = alignBase(alignItems);
      alignClasses = cls === "" ? [] : [cls];
    }
  } else {
    alignClasses = [];
  }
  let justifyClasses;
  if (justifyContent !== undefined) {
    if (typeof justifyContent === "object") {
      justifyClasses = [];
    } else {
      let cls$1 = justifyBase(justifyContent);
      justifyClasses = cls$1 === "" ? [] : [cls$1];
    }
  } else {
    justifyClasses = [];
  }
  let directionClasses;
  if (flexDirection !== undefined) {
    if (typeof flexDirection === "object") {
      directionClasses = [];
    } else {
      let cls$2 = dirBase(flexDirection);
      directionClasses = cls$2 === "" ? [] : [cls$2];
    }
  } else {
    directionClasses = [];
  }
  let mbStyleVal = mbClassAndStyle[1];
  let mtStyleVal = mtClassAndStyle[1];
  let headArr = Belt_Array.concatMany([
    flexClass,
    directionClasses,
    alignClasses,
    justifyClasses
  ]);
  let head = headArr.join(" ");
  let computedClasses = TailwindMerge.twMerge([
    head,
    Stdlib_Option.getOr(mtClassAndStyle[0], ""),
    Stdlib_Option.getOr(mbClassAndStyle[0], ""),
    Stdlib_Option.getOr(props.className, "")
  ]);
  let style = mtStyleVal !== undefined ? (
      mbStyleVal !== undefined ? ({
          marginBottom: mbStyleVal,
          marginTop: mtStyleVal
        }) : ({
          marginTop: mtStyleVal
        })
    ) : (
      mbStyleVal !== undefined ? ({
          marginBottom: mbStyleVal
        }) : ({})
    );
  return JsxRuntime.jsx("div", {
    children: children !== undefined ? children : null,
    className: computedClasses,
    style: style
  });
}

let View = {
  make: View__Jsx3$View
};

let Responsive;

let make = View__Jsx3$View;

exports.Responsive = Responsive;
exports.pxToString = pxToString;
exports.View = View;
exports.make = make;
/* tailwind-merge Not a pure module */
